import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Modal from "@client/controls/Modal/component";
import * as React from "react";
import Content from "./Content/container";

export type MapProps = RootContainerProps & {
  isLoading: boolean;
  isVisible: boolean;
  name: string;
};

export interface ActionProps {
  onClose: () => void;
}

export default (props: ActionProps & MapProps) => (
  <Modal
    className="wsc_course_lesson_modal narrow"
    hasBackdrop
    isAdminColor={false}
    isCentered
    isFullScreenAllowed
    isLoading={props.isLoading}
    isVisible={props.isVisible}
    onClose={props.onClose}
    width="1200px"
  >
    <Modal.Header title={props.name} />
    <Modal.Body>
      <Content {...getRootContainerProps(props)} />
    </Modal.Body>
  </Modal>
);
